import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import './service-request.css';
import moment from 'moment';
import { useIntl } from 'react-intl';
import {
    IErrorSNState,
    ISerialNumber,
    IServiceRequestExchanges,
    IServiceRequestInitial,
    getColorExchangeInitial,
    getSerialNumberInitial,
} from '../../../models/service-request';
import ServiceRequestSN from './service-request-SN';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import {
    clearDeviceDetails,
    loadDevice,
} from '../../../store/device/device-actions';
import { IPatientDevice } from '../../../models/device';
import FirstConsentModal from '../warranty-center/firstConsentModal';
import SecondConsentModal from '../warranty-center/secondConsentModal';
import { getPartNumberOptions } from '../../../api/service-request-api';
import { designationHook } from '../../../hooks/pn-or-desination-hook';
interface IColorExchangeProps {
    colorExchangeState: ISerialNumber[];
    setColorExchangeState: Dispatch<React.SetStateAction<ISerialNumber[]>>;
    deviceData: IPatientDevice | null;
    loadDevice: (serialNumber: string) => Promise<void>;
    clearDeviceDetails: () => Promise<void>;
    serviceRequest: IServiceRequestInitial;
    setServiceRequest: Dispatch<SetStateAction<IServiceRequestInitial>>;
    validating: boolean;
    errorSN: IErrorSNState;
    setErrorSN: Dispatch<React.SetStateAction<IErrorSNState>>;
}
export const ColorExchange = ({
    colorExchangeState,
    setColorExchangeState,
    deviceData,
    loadDevice,
    clearDeviceDetails,
    serviceRequest,
    setServiceRequest,
    validating,
    errorSN,
    setErrorSN,
}: IColorExchangeProps) => {
    const [hasConsent, setHasConsent] = useState(false);
    const [showFirstConsentModal, SetShowFirstConsentModal] = useState(false);
    const [showSecondConsentModal, SetShowSecondConsentModal] = useState(false);
    const [current, setCurrent] = useState(0);
    const [currentSN, setCurrentSN] = useState(1);
    const [lookingUpSN1, setLookingUpSN1] = useState(false);
    const [lookingUpSN2, setLookingUpSN2] = useState(false);
    const intl = useIntl();

    const getFirstTrueKey = (obj: IErrorSNState): number => {
        for (const key in obj) {
            if (obj[key]) return parseInt(key);
        }
        return current;
    };

    const setErrorSNState = (exchanges: IServiceRequestExchanges[]) => {
        const errorSNState = exchanges.reduce(
            (acc: IErrorSNState, exchange, index) => {
                acc[index] = null;
                return acc;
            },
            {}
        );
        setErrorSN(errorSNState);
    };

    const handleOnBlur = (pairDeviceSN?: string) => {
        if (pairDeviceSN) {
            setLookingUpSN2(true);
            loadDevice(pairDeviceSN);
        } else {
            if (
                (colorExchangeState[current].SN1 &&
                    colorExchangeState[current].SN1changed) ||
                (colorExchangeState[current].SN2 &&
                    colorExchangeState[current].SN2changed)
            ) {
                if (currentSN === 1) {
                    setLookingUpSN1(true);
                    loadDevice(colorExchangeState[current].SN1);
                }
                if (currentSN === 2) {
                    setLookingUpSN2(true);
                    loadDevice(colorExchangeState[current].SN2);
                }
            }
            if (
                (!colorExchangeState[current].SN1 && currentSN === 1) ||
                (!colorExchangeState[current].SN2 && currentSN === 2)
            ) {
                setColorExchangeState(
                    colorExchangeState.map((obj, i) =>
                        i === current
                            ? {
                                  ...obj,
                                  RN1: currentSN === 1 ? '' : obj.RN1,
                                  RN2: currentSN === 2 ? '' : obj.RN2,
                                  device1:
                                      currentSN === 1 ? undefined : obj.device1,
                                  pairDevice1:
                                      currentSN === 1
                                          ? undefined
                                          : obj.pairDevice1,
                                  device2:
                                      currentSN === 2 ? undefined : obj.device2,
                                  error1: currentSN === 1 ? '' : obj.error1,
                                  error2: currentSN === 2 ? '' : obj.error2,
                                  warning1: currentSN === 1 ? '' : obj.warning1,
                                  warning2: currentSN === 2 ? '' : obj.warning2,
                                  SN1changed: false,
                                  SN2changed: false,
                                  colors: currentSN === 1 ? [] : obj.colors,
                                  newColor: currentSN === 1 ? '' : obj.newColor,
                                  patient1First:
                                      currentSN === 1 ? '' : obj.patient1First,
                                  patient1Last:
                                      currentSN === 1 ? '' : obj.patient1Last,
                                  patient2First:
                                      currentSN === 2 ? '' : obj.patient2First,
                                  patient2Last:
                                      currentSN === 2 ? '' : obj.patient2Last,
                              }
                            : obj
                    )
                );
            }
        }
    };

    useEffect(() => {
        (async () => {
            if (deviceData !== null && deviceData !== undefined) {
                if (deviceData.unavailable) {
                    currentSN === 1
                        ? setLookingUpSN1(false)
                        : setLookingUpSN2(false);
                    const error = intl.formatMessage({
                        id: 'Our_apologies_serial_number_lookup',
                        defaultMessage:
                            'Our apologies, serial number lookup is currently down for maintenance - please try again later',
                    });
                    setColorExchangeState(
                        colorExchangeState.map((obj, i) =>
                            i === current
                                ? {
                                      ...obj,
                                      error1:
                                          currentSN === 1 ? error : obj.error1,
                                      error2:
                                          currentSN === 2 ? error : obj.error2,
                                      SN1changed: false,
                                      SN2changed: false,
                                      device1:
                                          currentSN === 1
                                              ? undefined
                                              : obj.device1,
                                      device2:
                                          currentSN === 2
                                              ? undefined
                                              : obj.device2,
                                      warning1:
                                          currentSN === 1 ? '' : obj.warning1,
                                      warning2:
                                          currentSN === 2 ? '' : obj.warning2,
                                  }
                                : obj
                        )
                    );
                } else if (
                    deviceData.device === null ||
                    !deviceData.device.serialNumber
                ) {
                    currentSN === 1
                        ? setLookingUpSN1(false)
                        : setLookingUpSN2(false);
                    const error = intl.formatMessage({
                        id: 'Invalid_serial_number',
                        defaultMessage: 'Invalid serial number',
                    });
                    setColorExchangeState(
                        colorExchangeState.map((obj, i) =>
                            i === current
                                ? {
                                      ...obj,
                                      error1:
                                          currentSN === 1 ? error : obj.error1,
                                      error2:
                                          currentSN === 2 ? error : obj.error2,
                                      SN1changed: false,
                                      SN2changed: false,
                                      device1:
                                          currentSN === 1
                                              ? undefined
                                              : obj.device1,
                                      device2:
                                          currentSN === 2
                                              ? undefined
                                              : obj.device2,
                                      warning1:
                                          currentSN === 1 ? '' : obj.warning1,
                                      warning2:
                                          currentSN === 2 ? '' : obj.warning2,
                                  }
                                : obj
                        )
                    );
                } else if (
                    (deviceData.device.serialNumber &&
                        !deviceData.device.partNumber) ||
                    deviceData.device.productClass === 'Custom' ||
                    !deviceData.device.color
                ) {
                    currentSN === 1
                        ? setLookingUpSN1(false)
                        : setLookingUpSN2(false);
                    const error = intl.formatMessage({
                        id: 'Color_change_not_available_for_this_product',
                        defaultMessage:
                            'Color change not available for this product',
                    });
                    setColorExchangeState(
                        colorExchangeState.map((obj, i) =>
                            i === current
                                ? {
                                      ...obj,
                                      error1:
                                          currentSN === 1 ? error : obj.error1,
                                      error2:
                                          currentSN === 2 ? error : obj.error2,
                                      SN1changed: false,
                                      SN2changed: false,
                                      device1:
                                          currentSN === 1
                                              ? undefined
                                              : obj.device1,
                                      device2:
                                          currentSN === 2
                                              ? undefined
                                              : obj.device2,
                                      warning1:
                                          currentSN === 1 ? '' : obj.warning1,
                                      warning2:
                                          currentSN === 2 ? '' : obj.warning2,
                                  }
                                : obj
                        )
                    );
                } else {
                    const { data: options } = await getPartNumberOptions(
                        deviceData.device.partNumber
                    );
                    const filteredOptions = options!.Body.filter(
                        (obj) =>
                            obj.name !== deviceData.device.color.name &&
                            obj.type === 5
                    );
                    const purchaseDateParsed = moment.utc(
                        deviceData.device.purchaseDate
                    );
                    const cutOffDate = moment().subtract(90, 'd');
                    if (
                        (currentSN === 1 &&
                            colorExchangeState[current].device2 &&
                            designationHook(
                                colorExchangeState[current].device2!.partNumber
                            ) !==
                                designationHook(
                                    deviceData.device.partNumber
                                )) ||
                        (currentSN === 2 &&
                            colorExchangeState[current].device1 &&
                            designationHook(
                                colorExchangeState[current].device1!.partNumber
                            ) !== designationHook(deviceData.device.partNumber))
                    ) {
                        currentSN === 1
                            ? setLookingUpSN1(false)
                            : setLookingUpSN2(false);
                        const error =
                            intl.formatMessage({
                                id: 'This_device_cannot_be_submitted_with_the_other_device',
                                defaultMessage:
                                    'This device cannot be submitted with the other device.',
                            }) +
                            ' ' +
                            intl.formatMessage({
                                id: 'Please_use_the_Add_Another_Serial_button',
                                defaultMessage:
                                    'Please use the ”Add Another Serial #” button to request an exchange for this device.',
                            });
                        setColorExchangeState(
                            colorExchangeState.map((obj, i) =>
                                i === current
                                    ? {
                                          ...obj,
                                          error1:
                                              currentSN === 1
                                                  ? error
                                                  : obj.error1,
                                          error2:
                                              currentSN === 2
                                                  ? error
                                                  : obj.error2,
                                          SN1changed: false,
                                          SN2changed: false,
                                          device1:
                                              currentSN === 1
                                                  ? undefined
                                                  : obj.device1,
                                          device2:
                                              currentSN === 2
                                                  ? undefined
                                                  : obj.device2,
                                          warning1:
                                              currentSN === 1
                                                  ? ''
                                                  : obj.warning1,
                                          warning2:
                                              currentSN === 2
                                                  ? ''
                                                  : obj.warning2,
                                      }
                                    : obj
                            )
                        );
                    } else if (filteredOptions.length) {
                        currentSN === 1
                            ? setLookingUpSN1(false)
                            : setLookingUpSN2(false);

                        const mappedOptions = filteredOptions.map((obj) => ({
                            text: obj.name,
                            value: obj.name,
                        }));
                        const warningCutOff = intl.formatMessage({
                            id: 'We_are_sorry_but_this_device_is_not_eligible_for_color_exchange',
                            defaultMessage:
                                'This device does not appear to be eligible for color exchange. Please contact your Sales Representative for a Reference Number.',
                        });
                        setColorExchangeState(
                            colorExchangeState.map((obj, i) =>
                                i === current
                                    ? {
                                          ...obj,
                                          device1:
                                              currentSN === 1
                                                  ? deviceData.device
                                                  : obj.device1,
                                          pairDevice1:
                                              currentSN === 1 &&
                                              deviceData.pairDevice
                                                  ? deviceData.pairDevice
                                                  : obj.pairDevice1,
                                          device2:
                                              currentSN === 2
                                                  ? deviceData.device
                                                  : obj.device2,
                                          error1:
                                              currentSN === 1 ? '' : obj.error1,
                                          error2:
                                              currentSN === 2 ? '' : obj.error2,
                                          warning1:
                                              currentSN === 1 &&
                                              moment(
                                                  purchaseDateParsed
                                              ).isBefore(cutOffDate)
                                                  ? warningCutOff
                                                  : obj.warning1,
                                          warning2:
                                              currentSN === 2 &&
                                              moment(
                                                  purchaseDateParsed
                                              ).isBefore(cutOffDate)
                                                  ? warningCutOff
                                                  : obj.warning2,
                                          SN1changed: false,
                                          SN2changed: false,
                                          colors:
                                              currentSN === 1
                                                  ? mappedOptions
                                                  : obj.colors,
                                          newColor:
                                              currentSN === 1 &&
                                              mappedOptions.length
                                                  ? mappedOptions[0].text
                                                  : obj.newColor,
                                          patient1First:
                                              currentSN === 1
                                                  ? deviceData.patientFirstName
                                                  : obj.patient1First,
                                          patient1Last:
                                              currentSN === 1
                                                  ? deviceData.patientLastName
                                                  : obj.patient1Last,
                                          patient2First:
                                              currentSN === 2
                                                  ? deviceData.patientFirstName
                                                  : obj.patient2First,
                                          patient2Last:
                                              currentSN === 2
                                                  ? deviceData.patientLastName
                                                  : obj.patient2Last,
                                      }
                                    : obj
                            )
                        );
                    } else {
                        currentSN === 1
                            ? setLookingUpSN1(false)
                            : setLookingUpSN2(false);
                        const error = intl.formatMessage({
                            id: 'Color_change_not_available_for_this_product',
                            defaultMessage:
                                'Color change not available for this product',
                        });
                        setColorExchangeState(
                            colorExchangeState.map((obj, i) =>
                                i === current
                                    ? {
                                          ...obj,
                                          error1:
                                              currentSN === 1
                                                  ? error
                                                  : obj.error1,
                                          error2:
                                              currentSN === 2
                                                  ? error
                                                  : obj.error2,
                                          SN1changed: false,
                                          SN2changed: false,
                                          device1:
                                              currentSN === 1
                                                  ? undefined
                                                  : obj.device1,
                                          device2:
                                              currentSN === 2
                                                  ? undefined
                                                  : obj.device2,
                                          warning1:
                                              currentSN === 1
                                                  ? ''
                                                  : obj.warning1,
                                          warning2:
                                              currentSN === 2
                                                  ? ''
                                                  : obj.warning2,
                                      }
                                    : obj
                            )
                        );
                    }
                }
            }
        })();
        return () => {
            clearDeviceDetails();
        };
    }, [deviceData]);

    useEffect(() => {
        if (serviceRequest.exchanges.length) {
            setCurrent(serviceRequest.exchanges.length - 1);
        }
    }, [serviceRequest.exchanges.length]);

    useEffect(() => {
        if (
            validating &&
            Object.values(errorSN).some((errorSN) => errorSN === true)
        ) {
            const pageToNavigateTo = getFirstTrueKey(errorSN);
            setCurrent(pageToNavigateTo);
        }
    }, [validating]);

    useEffect(() => {
        if (validating) {
            const errorRefs: Element[] = Array.from(
                document.getElementsByClassName('has-error')
            );
            if (errorRefs.length > 0) {
                const inputRefs: HTMLInputElement[] = Array.from(
                    errorRefs[0].getElementsByTagName('input')
                );
                if (inputRefs.length > 0) inputRefs[0].focus();
            }
        }
    }, [current]);

    return (
        <>
            <div className="form-horizontal tabbed-form gutter-top header-service-request">
                <button
                    className="btn btn-default pull-right btn-service-request"
                    name="removeSerialNumber"
                    onClick={() => {
                        if (serviceRequest.exchanges) {
                            if (serviceRequest.exchanges.length === 1) {
                                setColorExchangeState([
                                    getSerialNumberInitial(),
                                ]);
                                setServiceRequest((serviceRequest) => ({
                                    ...serviceRequest,
                                    exchanges: [getColorExchangeInitial()],
                                }));
                            } else {
                                const exchanges = [...serviceRequest.exchanges];
                                const data = [...colorExchangeState];
                                exchanges.splice(current, 1);
                                data.splice(current, 1);
                                setColorExchangeState(data);
                                setServiceRequest((serviceRequest) => ({
                                    ...serviceRequest,
                                    exchanges: [...exchanges],
                                }));
                                setErrorSNState(exchanges);
                            }
                        }
                    }}
                >
                    <span
                        style={{ padding: '0' }}
                        className="visible-xs glyphicon glyphicon-minus"
                    ></span>
                    <span className="hidden-xs">
                        {intl.formatMessage({
                            id: 'Remove_This_Serial',
                            defaultMessage: 'Remove This Serial #',
                        })}
                    </span>
                </button>
                <button
                    className="btn btn-default pull-right btn-service-request"
                    name="addSerialNumber"
                    onClick={() => {
                        if (serviceRequest.exchanges.length >= 10) {
                            return;
                        } else {
                            setColorExchangeState((prev) => [
                                ...prev,
                                getSerialNumberInitial(),
                            ]);
                            const exchanges = [
                                ...serviceRequest.exchanges,
                                getColorExchangeInitial(),
                            ];
                            setServiceRequest((serviceRequest) => ({
                                ...serviceRequest,
                                exchanges: [...exchanges],
                            }));
                            setErrorSNState(exchanges);
                        }
                    }}
                >
                    <span
                        style={{ padding: '0' }}
                        className="visible-xs glyphicon glyphicon-plus"
                    ></span>
                    <span className="hidden-xs">
                        {intl.formatMessage({
                            id: 'Add_Another_Serial',
                            defaultMessage: 'Add Another Serial #',
                        })}
                    </span>
                </button>
                <h2 style={{ color: '#58595b', height: '54px' }}>
                    {intl.formatMessage({
                        id: 'Exchanges',
                        defaultMessage: 'Exchanges',
                    })}
                </h2>
            </div>
            {serviceRequest.exchanges && (
                <div className="SN-wrapper">
                    {serviceRequest.exchanges.map((exchange, index) => {
                        return (
                            <ServiceRequestSN
                                key={index}
                                index={index}
                                lookingUpSN1={lookingUpSN1}
                                lookingUpSN2={lookingUpSN2}
                                setCurrentSN={setCurrentSN}
                                handleOnBlur={handleOnBlur}
                                current={current}
                                setCurrent={setCurrent}
                                data={colorExchangeState}
                                setData={setColorExchangeState}
                                validating={validating}
                                setErrorSN={setErrorSN}
                                hasConsent={hasConsent}
                                SetShowFirstConsentModal={
                                    SetShowFirstConsentModal
                                }
                            />
                        );
                    })}
                </div>
            )}
            {showFirstConsentModal && (
                <FirstConsentModal
                    onAccept={() => {
                        SetShowFirstConsentModal(false);
                        setHasConsent(true);
                        if (currentSN === 1) {
                            setLookingUpSN1(true);
                            loadDevice(colorExchangeState[current].SN1);
                        }
                        if (currentSN === 2) {
                            setLookingUpSN2(true);
                            loadDevice(colorExchangeState[current].SN2);
                        }
                    }}
                    onClose={() => {
                        SetShowFirstConsentModal(false);
                        SetShowSecondConsentModal(true);
                    }}
                />
            )}
            {showSecondConsentModal && (
                <SecondConsentModal
                    onAccept={() => undefined}
                    onClose={() => {
                        SetShowSecondConsentModal(false);
                    }}
                />
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    deviceData: state.deviceData ? state.deviceData.data! : null,
});

const mapDispatchToProps = {
    loadDevice,
    clearDeviceDetails,
};

const colorExchangeContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ColorExchange);

export default colorExchangeContainer;
